import { render, staticRenderFns } from "./ProdDistintaAvanzamentoAdapter.vue?vue&type=template&id=70132b38&scoped=true&"
import script from "./ProdDistintaAvanzamentoAdapter.vue?vue&type=script&lang=js&"
export * from "./ProdDistintaAvanzamentoAdapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70132b38",
  null
  
)

export default component.exports